// extracted by mini-css-extract-plugin
export default {"wrapper":"PasswordSendLink_wrapper__eePnH","box":"PasswordSendLink_box__AnVum","form":"PasswordSendLink_form__1islC","notice":"PasswordSendLink_notice__m4ifg"};